<template>
  <div class="layout">
    <div class="layout__header">
			<div class="layout__title">
				<h3>
					Amortizaciones
				</h3>
			</div>
		</div>
    <div class="row">
      <div class="col-xs-12" style="max-height: 420px; overflow-y: auto;">
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Cuota</th>
                <th>Valor</th>
                <th>Total pagado</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(amortizacion, index) in form.amortizaciones" :key="index">
                <th scope="row">
                  {{ amortizacion.cuota }}
                </th>
                <td>
                  {{ moneyFormat(amortizacion.valor, 2) }}
                </td>
                <td>
                  {{ moneyFormat(amortizacion.total_pagado, 2) }}
                </td>
                <td>
                  {{ moneyFormat(amortizacion.saldo, 2) }}
                </td>
              </tr>
              <tr v-show="form.amortizaciones.length === 0">
                <td colspan="4">
                  <strong>No se ha generado amortizaciones...</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
			required: false,
			type: Object,
			default: function () {
				return {};
			},
		},
  },
  data: function () {
		return {
      moneyFormat: moneyFormat,
			modelValue: JSON.parse(JSON.stringify(this.value)),
      form: {
        amortizaciones: [],
      }
		}
	},
  methods: {
    cargarPrestamo: function () {
      const id = this.modelValue.prestamo_id;
      let urlApi = `${url}/prestamos/cargar-prestamo/${id}`;
      axios
      .get(urlApi)
      .then((response) => {
        let prestamo = response.data.prestamo;
        this.form.amortizaciones.splice(0, this.form.amortizaciones.length);
        for (let i = 0; i < prestamo.amortizaciones.length; i++) {
          this.form.amortizaciones.push({
            cuota: prestamo.amortizaciones[i].cuota,
            valor: prestamo.amortizaciones[i].valor,
            total_pagado: prestamo.amortizaciones[i].total_pagado,
            saldo: prestamo.amortizaciones[i].saldo,
          });
        }
      })
      .catch((error) => {
        swal("Error", "Hubo un error al cargar el préstamo", "error");
      });
    },
    cerrar: function () {
      this.$emit("cerrar");
    },
  },
  mounted: function () {
    this.cargarPrestamo();
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/Amortizaciones.vue